import { Camera } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SLOTS = [
  { id: "01", big: true, label: "Fachada completa" },
  { id: "02", big: false, label: "Antes / Depois" },
  { id: "03", big: false, label: "Detalhe de acabamento" },
  { id: "04", big: false, label: "Equipe em altura" },
  { id: "05", big: false, label: "Textura / Grafiato" },
  { id: "06", big: true, label: "Obra residencial" },
];

export const Portfolio = () => (
  <section id="portfolio" data-testid="portfolio-section" className="mx-auto max-w-7xl px-6 py-24 md:py-32">
    <Reveal>
      <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Portfólio ]</p>
      <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
        Antes / Depois
      </h2>
      <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/60">
        Espaços reservados para as fotos reais das primeiras obras KRONO. Transparência total: nada de banco de imagem aqui.
      </p>
    </Reveal>
    <div className="mt-16 grid auto-rows-[180px] grid-cols-2 gap-0 border-l border-t border-white/10 md:auto-rows-[220px] md:grid-cols-4">
      {SLOTS.map((s, i) => (
        <Reveal
          key={s.id}
          delay={i * 0.05}
          className={s.big ? "col-span-2 row-span-2" : "col-span-1 row-span-1"}
        >
          <div
            data-testid={`portfolio-slot-${s.id}`}
            className="placeholder-stripes group relative flex h-full flex-col justify-between overflow-hidden border-b border-r border-white/10 bg-[#0A0A0A] p-5 grayscale transition-colors hover:bg-[#111]"
          >
            <span className="font-mono text-xs text-krono">OBRA {s.id}</span>
            <div>
              <Camera className="mb-3 h-5 w-5 text-white/30 transition-colors group-hover:text-krono" />
              <p className="font-display text-sm font-semibold text-white/70">{s.label}</p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                Foto real em breve — sua obra aqui
              </p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
